import { ref, onValue, push } from 'firebase/database';
import { rtdb } from '../utils/firebase/config';
import { uploadImage } from './storageService';

const WHATSAPP_ROOT = 'whatsapp';

function chatPreviewAndTime(messagesObj) {
    let lastTime = 0;
    let preview = '';
    if (!messagesObj || typeof messagesObj !== 'object') {
        return { lastTime, preview };
    }
    Object.values(messagesObj).forEach((m) => {
        if (!m || typeof m !== 'object') return;
        const t = parseInt(String(m.time), 10) || 0;
        if (t >= lastTime) {
            lastTime = t;
            if (typeof m.text === 'string' && m.text.trim()) {
                preview = m.text;
            } else if (typeof m.image === 'string' && m.image.trim()) {
                preview = 'Imagen';
            } else {
                preview = '';
            }
        }
    });
    return { lastTime, preview };
}

export function subscribeWhatsappChats(onChats) {
    const r = ref(rtdb, WHATSAPP_ROOT);
    return onValue(
        r,
        (snap) => {
            const val = snap.val();
            if (!val || typeof val !== 'object') {
                onChats([]);
                return;
            }
            const chats = Object.entries(val).map(([id, msgs]) => {
                const { lastTime, preview } = chatPreviewAndTime(msgs);
                return { id, lastTime, preview };
            });
            chats.sort((a, b) => b.lastTime - a.lastTime);
            onChats(chats);
        },
        () => {
            onChats([]);
        }
    );
}

export function subscribeWhatsappMessages(phoneId, onMessages) {
    if (!phoneId) {
        return () => {};
    }
    const r = ref(rtdb, `${WHATSAPP_ROOT}/${phoneId}`);
    return onValue(
        r,
        (snap) => {
            const val = snap.val();
            if (!val || typeof val !== 'object') {
                onMessages([]);
                return;
            }
            const rows = Object.entries(val)
                .map(([key, data]) => {
                    if (!data || typeof data !== 'object') return null;
                    return {
                        key,
                        role: data.role,
                        text: data.text,
                        image: data.image,
                        time: data.time,
                    };
                })
                .filter(Boolean)
                .sort(
                    (a, b) =>
                        (parseInt(String(a.time), 10) || 0) -
                        (parseInt(String(b.time), 10) || 0)
                );
            onMessages(rows);
        },
        () => {
            onMessages([]);
        }
    );
}

export async function pushAdminMessage(phoneId, text) {
    const trimmed = String(text || '').trim();
    if (!phoneId || !trimmed) {
        throw new Error('Usuario y mensaje son obligatorios');
    }
    const r = ref(rtdb, `${WHATSAPP_ROOT}/${phoneId}`);
    await push(r, {
        role: 'admin',
        text: trimmed,
        time: String(Math.floor(Date.now() / 1000)),
    });
}

export async function pushAdminMediaMessage(phoneId, payload = {}) {
    const trimmedText = String(payload.text || '').trim();
    const file = payload.imageFile || null;
    if (!phoneId || (!trimmedText && !file)) {
        throw new Error('Debes escribir texto o adjuntar una imagen');
    }

    let imageUrl = '';
    if (file) {
        const uploadResult = await uploadImage(file, `whatsapp/admin/${phoneId}`);
        if (!uploadResult.success || !uploadResult.url) {
            throw new Error(uploadResult.error || 'No se pudo subir la imagen');
        }
        imageUrl = uploadResult.url;
    }

    const data = {
        role: 'admin',
        time: String(Math.floor(Date.now() / 1000)),
    };

    if (trimmedText) {
        data.text = trimmedText;
    }
    if (imageUrl) {
        data.image = imageUrl;
    }

    const r = ref(rtdb, `${WHATSAPP_ROOT}/${phoneId}`);
    await push(r, data);
}
